export enum PaymentResponseStatus {
  SUCCESS = 'SUCCESS',
  NO_ITEMS_IN_STORE = 'NO_ITEMS_IN_STORE',
  NOT_ALL_ITEMS_IN_STORE = 'NOT_ALL_ITEMS_IN_STORE',
  ERROR = 'ERROR',
}
